import { render, staticRenderFns } from "./motor.vue?vue&type=template&id=5f93a305&scoped=true&"
import script from "./motor.vue?vue&type=script&lang=js&"
export * from "./motor.vue?vue&type=script&lang=js&"
import style0 from "./motor.vue?vue&type=style&index=0&id=5f93a305&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f93a305",
  null
  
)

export default component.exports